import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

interface TrustExpandingProps {
  name: string;
  children?: React.ReactNode; 
}

const TrustExpanding: React.FC<TrustExpandingProps> = ({ name, children }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex flex-col rounded-2xl mt-3 text-lg bg-career-dark-50  text-career-dark-600 font-semibold">
      <button
        className={`flex flex-row space-x-5 items-center p-5 hover:cursor-pointer ${isExpanded && 'bg-purple-500 dark:bg-purple-700 text-white'
          } rounded-t-xl`}
        onClick={toggleExpand}
      >
        <div className="flex-1 w-full text-start">
          <div>
            {name}
          </div>
        </div>
        <div className="flex-shrink-0 flex items-center justify-center text-gray-400">
          <FontAwesomeIcon icon={faChevronDown} height={24} width={24} />
        </div>
      </button>
      <div
        className={`transition-all duration-500 overflow-hidden ${isExpanded ? 'max-h-[600px]' : 'max-h-0'
          } rounded-b-xl`}
      >
        <div className={`p-3 font-normal ${isExpanded && 'bg-purple-500 dark:bg-purple-700 text-white'}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default TrustExpanding;
